import type {
  bankingApiSpec,
  onboardingApiSpec
} from "@wingspanhq/wingspan-api-types";

const requireAdditionalInformationForType = ["Banking", "TaxWithholding"];

function getOnlyRepresentativeTaxIdMissing(
  missingData?: onboardingApiSpec.operations["getVerificationMissingData"]["responses"]["200"]["content"]["application/json"]
) {
  return (
    missingData?.requiredFields?.length === 1 &&
    missingData.requiredFields[0] === "Representative.individualTaxId"
  );
}

function getDocumentsMissing(
  missingData?: onboardingApiSpec.operations["getVerificationMissingData"]["responses"]["200"]["content"]["application/json"]
) {
  return !!missingData?.completeOnboardingToken;
}

export function getRequireAdditionalInformation(
  internalAccount: bankingApiSpec.InternalAccount,
  missingData?: onboardingApiSpec.operations["getVerificationMissingData"]["responses"]["200"]["content"]["application/json"],
  featureFlags?: {
    bankingAdditionalInfo?: boolean;
  }
) {
  if (!featureFlags?.bankingAdditionalInfo) {
    return false;
  }

  if (!requireAdditionalInformationForType.includes(internalAccount.type)) {
    return false;
  }

  if (internalAccount.status !== "Pending") {
    return false;
  }

  if (getOnlyRepresentativeTaxIdMissing(missingData)) {
    return true;
  }

  if (getDocumentsMissing(missingData)) {
    return true;
  }

  return false;
}
